'use client';
import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import './subHeroBanner.scss';
import Image from 'next/image';
import { imageData } from '@/config/defaultBlur';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import { urlForImage } from '@/sanity/lib/utils';
import VideoPlayer from '@/components/videoPlayer/videoPlayer';
import { GetAboutPageQueryResult } from '@/sanity.types';
import { PortableTextBlock } from 'next-sanity';

interface SubHeroBannerProps {
  subHeroBannerData?: NonNullable<GetAboutPageQueryResult>['secondHero'];
}

export default function SubHeroBanner({
  subHeroBannerData,
}: SubHeroBannerProps) {
  const background = subHeroBannerData?.background;
  const content = subHeroBannerData?.content?.text;
  const position = subHeroBannerData?.content?.position;
  const hasImage = !!background?.image?.asset;
  const hasVideo = !!background?.video;
  const imageAlt = background?.image?.alt || 'sub hero banner';
  const imageUrl = background?.image
    ? (urlForImage(background.image)?.url() as string)
    : '/n_images/default-blog.jpg';

  const blurDataUrl =
    background?.image?.imgAsset?.metadata?.lqip || imageData.blurImage;
  const mapPositionToAlign = (pos?: 'left' | 'center' | 'right') => {
    switch (pos) {
      case 'left':
        return 'start';
      case 'center':
        return 'center';
      case 'right':
        return 'end';
      default:
        return 'start';
    }
  };
  return (
    <section
      // className={`sub-hero-content ${!hasImage ? 'text-black' : 'text-white'}`}
      className={`sub-hero-content text-white`}
    >
      <Container>
        <Row
          className={`hero-text justify-content-end align-items-${mapPositionToAlign(position)}`}
        >
          <Col md={8}>
            <div className="lead">
              {content && (
                <LandingPortableText value={content as PortableTextBlock[]} />
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="hero-image">
        {hasVideo ? (
          <div className="cover-video">
            <VideoPlayer
              url={background.video ?? ''}
              autoplay={true}
              height={800}
              loop={true}
              controls={false}
            />
          </div>
        ) : hasImage ? (
          <Image
            src={imageUrl}
            alt={imageAlt}
            width={2800}
            height={1464}
            quality={100}
            placeholder="blur"
            blurDataURL={blurDataUrl}
            priority
          />
        ) : (
          <div className="fallback-background" />
        )}
      </div>
    </section>
  );
}
